var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0634 5.03333C20.0643 4.93658 20.0268 4.8434 19.9592 4.7741L16.2926 1.10743C16.2236 1.03942 16.1302 1.00192 16.0333 1.0033V1H5.03335C4.42583 1 3.93335 1.49248 3.93335 2.1V21.9C3.93335 22.5075 4.42583 23 5.03335 23H18.9667C19.5742 23 20.0667 22.5075 20.0667 21.9V5.03333H20.0634ZM16.4 2.2518L18.8149 4.66667H16.7667C16.5642 4.66667 16.4 4.50249 16.4 4.3V2.2518ZM19.3334 21.9C19.3334 22.1025 19.1692 22.2667 18.9667 22.2667H5.03335C4.83086 22.2667 4.66668 22.1025 4.66668 21.9V2.1C4.66668 1.89751 4.83086 1.73333 5.03335 1.73333H15.6667V4.3C15.6667 4.90752 16.1592 5.4 16.7667 5.4H19.3334V21.9Z",
    fill: "#0E5AA7",
    stroke: "#0E5AA7",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6 10.9C6.99248 10.9 6.5 11.3925 6.5 12C6.5 12.6075 6.99248 13.1 7.6 13.1C8.20752 13.1 8.7 12.6075 8.7 12C8.7 11.3925 8.20752 10.9 7.6 10.9ZM7.6 12.3667C7.39751 12.3667 7.23333 12.2025 7.23333 12C7.23333 11.7975 7.39751 11.6333 7.6 11.6333C7.80249 11.6333 7.96667 11.7975 7.96667 12C7.96667 12.2025 7.80249 12.3667 7.6 12.3667Z",
    fill: "#0E5AA7",
    stroke: "#0E5AA7",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 11.6333H10.1667V12.3667H17.5001V11.6333Z",
    fill: "#0E5AA7",
    stroke: "#0E5AA7",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6 7.23334C6.99248 7.23334 6.5 7.72582 6.5 8.33334C6.5 8.94086 6.99248 9.43334 7.6 9.43334C8.20752 9.43334 8.7 8.94086 8.7 8.33334C8.7 7.72582 8.20752 7.23334 7.6 7.23334ZM7.6 8.7C7.39751 8.7 7.23333 8.53583 7.23333 8.33334C7.23333 8.13085 7.39751 7.96667 7.6 7.96667C7.80249 7.96667 7.96667 8.13085 7.96667 8.33334C7.96667 8.53583 7.80249 8.7 7.6 8.7Z",
    fill: "#0E5AA7",
    stroke: "#0E5AA7",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 7.96667H10.1667V8.70001H17.5001V7.96667Z",
    fill: "#0E5AA7",
    stroke: "#0E5AA7",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6 14.5667C6.99248 14.5667 6.5 15.0592 6.5 15.6667C6.5 16.2742 6.99248 16.7667 7.6 16.7667C8.20752 16.7667 8.7 16.2742 8.7 15.6667C8.7 15.0592 8.20752 14.5667 7.6 14.5667ZM7.6 16.0333C7.39751 16.0333 7.23333 15.8692 7.23333 15.6667C7.23333 15.4642 7.39751 15.3 7.6 15.3C7.80249 15.3 7.96667 15.4642 7.96667 15.6667C7.96667 15.8692 7.80249 16.0333 7.6 16.0333Z",
    fill: "#0E5AA7",
    stroke: "#0E5AA7",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 15.3H10.1667V16.0333H17.5001V15.3Z",
    fill: "#0E5AA7",
    stroke: "#0E5AA7",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6 18.2333C6.99248 18.2333 6.5 18.7258 6.5 19.3333C6.5 19.9409 6.99248 20.4333 7.6 20.4333C8.20752 20.4333 8.7 19.9409 8.7 19.3333C8.7 18.7258 8.20752 18.2333 7.6 18.2333ZM7.6 19.7C7.39751 19.7 7.23333 19.5358 7.23333 19.3333C7.23333 19.1308 7.39751 18.9667 7.6 18.9667C7.80249 18.9667 7.96667 19.1308 7.96667 19.3333C7.96667 19.5358 7.80249 19.7 7.6 19.7Z",
    fill: "#0E5AA7",
    stroke: "#0E5AA7",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 18.9667H10.1667V19.7H17.5001V18.9667Z",
    fill: "#0E5AA7",
    stroke: "#0E5AA7",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 22,
    fill: "white",
    transform: "translate(3 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/DashboardActive.e1636e53e25be30974a35b6967e1a8f5.svg";
export { ForwardRef as ReactComponent };